<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">
          Добавление счетчика
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-form ref="addCounterForm">
        <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                xs12
                sm12
                md12
              >
                <v-text-field
                  v-model="counter.serial_num"
                  label="Серийный номер"
                  :rules="inputRules"
                  required
                />
              </v-flex>

              <v-flex
                xs12
                sm12
                md12
              >
                <v-autocomplete
                  v-model="counter.model_id"
                  :items="counters_models"
                  label="Модель"
                  item-text="name"
                  item-value="model_id"
                  :menu-props="{maxHeight:'auto'}"
                  :rules="inputRules"
                  required
                />
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
              >
                <v-text-field
                  v-model="counter.coeff"
                  label="Коэффициент трансформации"
                  :rules="inputRules"
                  required
                />
              </v-flex>
            </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="blue darken-1"
        text
        @click.native="addCounter"
      >
        Добавить
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click.native="cancelAdding()"
      >
        Отмена
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'CounterNew',
  data () {
    return {
      inputRules: [
        v => !!v || 'Заполните это поле!'
      ],
      counter: {
        'serial_num': ''
      },
      counters_models: []
    }
  },
  mounted () {
    this.getCountersModels()
  },
  methods: {
    cancelAdding: function () {
      this.$emit('cancel')
    },
    getCountersModels () {
      this.axios.get(`/api/counters_models/`)
        .then((response) => {
          this.counters_models = response.data.results
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addCounter () {
      if (this.validate()) {
        this.axios.post(`/api/counters/`, this.counter)
          .then(() => {
            this.$emit('added')
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    validate () {
      if (this.$refs.addCounterForm.validate()) {
        return true
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/counters/CounterNew.vue